import React, {
  Fragment,
  useEffect,
  useState,
  useMemo,
  useCallback,
  useRef,
} from "react";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  Progress,
  ListGroup,
  CardTitle,
  CardText,
  Badge,
  Container,
  Col,
  Row,
  Card,
  CardHeader,
  CardBody,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  Input,
  Label,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  Table,
  TabPane,
  Modal,
  ModalHeader,
  Form,
  ModalBody,
  FormFeedback,
  Spinner,
  UncontrolledTooltip,
} from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import DeleteModal from "../../Components/Common/DeleteModal";
import classnames from "classnames";
import moment from "moment";
import "moment-timezone";
import Select from "react-select";
//SimpleBar
import SimpleBar from "simplebar-react";
import { isEmpty, clone } from "lodash";
import Dropzone from "react-dropzone";
import Rating from "react-rating";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";
import lottie from "lottie-web";
import { defineElement } from "lord-icon-element";
import { getUser, resetUserState } from "../../store/users/action";
import {
  getTask as onGetTasks,
  addNewTask as onAddNewTask,
  updateTask as onUpdateTask,
  deleteTask as onDeleteTask,
  getTaskLoading,
  resetTaskState,
} from "../../store/task/action";
import {
  getTaskDetail as onGetTaskDetails,
  addNewTaskDetail as onAddNewTaskDetail,
  updateTaskDetail as onUpdateTaskDetail,
  deleteTaskDetail as onDeleteTaskDetail,
  getTaskDetailLoading,
  resetTaskDetailState,
} from "../../store/taskDetail/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ModalImage from "react-modal-image";

import defaultImg from "../../assets/images/users/user-dummy-img.jpg";
import { Link } from "react-router-dom";
import defaultfile from "../../assets/images/upload.png";
import ModalInputFile from "../../Components/ModalInputFile";
import { api } from "../../config";
import imgNotFound from "../../assets/images/users/img-remove.png";

defineElement(lottie.loadAnimation);
const TaskDetails = () => {
  const { taskId } = useParams();
  const [modalCompleted, setModalCompleted] = useState(false);
  const [modalUser, setModalUser] = useState(false);
  const [modalTimeEntry, setModalTimeEntry] = useState(false);
  const [modalProgress, setModalProgress] = useState(false);
  const [modalFile, setModalFile] = useState(false);
  const [modalView, setModalView] = useState(false);
  const [activeTab, setActiveTab] = useState("1-0");
  const [otherDocImg, setOtherDocImg] = useState([]);
  const [modalMedia, setModalMedia] = useState(false);

  const [currentbyte, setCurrentByte] = useState(0);
  const [totalbyte, setTotalByte] = useState(0);
  const [percentbyte, setPercentByte] = useState(0);
  const [moduleFileItem, setModuleFileItem] = useState([]);
  const [fileNameItem, setFileNameItem] = useState([]);
  const [activeFileUpload, setActiveFileUpload] = useState({});
  const [isUploadFile, setIsFileUpload] = useState(false);
  const [deletedFileId, setDeletedFileId] = useState("");
  const [fileView, setFileView] = useState();
  const [logo, setLogo] = useState(defaultfile);
  const [taskDetailFiles, setTaskDetailFiles] = useState([]);

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };
  const dispatch = useDispatch();
  const {
    tasks,
    isTaskCreated,
    isTaskSuccess,
    loading,
    error,
    taskDetails,
    taskDetailLoading,
    isTaskDetailCreated,
    isTaskDetailSuccess,
    users,
    userLoading,
    isMediaDeleted,
    files,
  } = useSelector((state) => ({
    tasks: state.Task.tasks,
    isTaskCreated: state.Task.isTaskCreated,
    isTaskSuccess: state.Task.isTaskSuccess,
    loading: state.Task.loading,
    error: state.Task.error,
    taskDetails: state.TaskDetail.taskDetails,
    taskDetailLoading: state.TaskDetail.loading,
    isTaskDetailCreated: state.TaskDetail.isTaskDetailCreated,
    isTaskDetailSuccess: state.TaskDetail.isTaskDetailSuccess,
    users: state.Users.users,
    userLoading: state.Users.loading,
    files: state.File.files,
  }));

  const [isSearch, setIsSearch] = useState(false);
  const [taskList, setTaskList] = useState([]);
  const [taskMinutes, setTaskMinutes] = useState(0);
  const [task, setTask] = useState([]);
  const [taskDetail, setTaskDetail] = useState([]);
  const [statusActive, setStatusActive] = useState([]);
  const [user, setUser] = useState(null);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [isAssigned, setIsAssigned] = useState(false);
  const [isReported, setIsReported] = useState(false);
  const [userList, setUserList] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);
  const [canCreate, setCanCreate] = useState(false);
  const [deleteModalAssigned, setDeleteModalAssigned] = useState(false);
  const [deleteModalReported, setDeleteModalReported] = useState(false);
  const [dataToDelete, setDataToDelete] = useState({});
  const [userRole, setRoles] = useState(null);
  const [userType, setUserType] = useState("user");
  const [mediaFiles, setMediaFiles] = useState();
  const [filesUsr, setFilesUsr] = useState();

  const handleSelectFile = (file) => {
    setOtherDocImg((val) => [...val, { filename: file.filename, originalname: file.originalname }]);

    toggleMedia();
  };

  const handleDeleteFile = (file) => {
    // if (isEdit) {
    //   const newState = otherDocImg.map((obj) => {
    //     if (obj.id === file.id) {
    //       return { id: file.id, filename: file.filename, isDeleted: true };
    //     }
    //     return obj;
    //   });
    //   setOtherDocImg(newState);
    // } else {
    //   const index = otherDocImg.findIndex((fl) => fl.filename === file.filename);
    //   setOtherDocImg((val) => [...val.slice(0, index), ...val.slice(index + 1)]);
    // }
    const index = otherDocImg.findIndex((fl) => fl.filename === file.filename);
    setOtherDocImg((val) => [...val.slice(0, index), ...val.slice(index + 1)]);
  };

  const toggleMedia = useCallback(() => {
    if (modalMedia) {
      setModalMedia(false);
    } else {
      setModalMedia(true);
    }
  }, [modalMedia]);

  useEffect(() => {
    if (isUploadFile) {
      // setTotalByte(totalbyte);
      switch (true) {
        case currentbyte <= totalbyte:
          setPercentByte(Math.ceil((currentbyte / totalbyte) * 100));
          break;
        default:
          break;
      }
    }
  }, [
    isUploadFile,
    totalbyte,
    currentbyte,
    percentbyte,
    setTotalByte,
    setPercentByte,
    setIsFileUpload,
  ]);

  useEffect(() => {
    if (percentbyte === 100 && isUploadFile) {
      const fc = [];
      const fcId = [];

      if (fileNameItem && fileNameItem.length > 0) {
        fileNameItem.forEach((itm) => {
          fc.push(itm);
          fcId.push({ file_id: itm.id });
        });
      }

      if (activeFileUpload && activeFileUpload.id) {
        fc.push({
          file_id: activeFileUpload.id,
          originalname: activeFileUpload.filename,
          filename: activeFileUpload.filejadi,
          size: activeFileUpload.filesize,
        });
        setFileNameItem(fc);
        // setKirim(true);

        fcId.push({ file_id: activeFileUpload.id });
        const o = {};
        setActiveFileUpload(o);
      }
      setTimeout(() => {
        setTotalByte(0);
        setCurrentByte(0);
        setPercentByte(0);
        setIsFileUpload(false);
      }, 3000);
    }
  }, [percentbyte, isUploadFile, fileNameItem, activeFileUpload]);

  useEffect(() => {
    if (isMediaDeleted) {
      const object = fileNameItem.findIndex(
        (obj) => obj.file_id === deletedFileId
      );
      if (object > -1) {
        fileNameItem.splice(object, 1);
      }
      const fc = fileNameItem;
      setFileNameItem(fc);
    }
  }, [isMediaDeleted, fileNameItem, deletedFileId]);

  const onStartFileUpload = useCallback((filesize) => {
      setIsFileUpload(true);
      setTotalByte(filesize);
      // totalbyte = filesize;
      // document.querySelector('#_total').innerText =  `Total Bytes: ${totalbyte}`
    }, [setTotalByte]);

  const onProgressFileUpload = useCallback((total) => {
      setCurrentByte(total);
      // setPercentByte(Math.ceil((currentbyte / totalbyte) * 100));
    }, [setCurrentByte]);

  const onEndFileUpload = useCallback((data) => {
      const js = JSON.parse(data.data);
      setTotalByte(parseInt(js.filesize));
      // const id = js.id;
      // handleFile(id);
      setActiveFileUpload(js);
      document.querySelector("#fUpload").value = "";
    }, [setActiveFileUpload]);

  const initFile = useCallback(() => {
    // const obj = JSON.parse(localStorage.getItem("authUser"));
    // const allowedmime = [
    //   "application/vnd.ms-excel",
    //   "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    //   "application/msword",
    //   "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    //   "application/pdf",
    //   "image/jpg",
    //   "image/jpeg",
    //   "image/png",
    // ];
    // const option = {
    //   idinput: "fUpload",
    //   userId: obj.data.id.toString(),
    //   clientId: obj?.data?.user_client ? obj?.data?.user_client.id.toString() : "",
    //   folder: "task",
    //   allowedmime: allowedmime,
    //   onStart: onStartFileUpload,
    //   onEnd: onEndFileUpload,
    //   onProgress: onProgressFileUpload,
    // };
    // Fileserver(option);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onStartFileUpload, onEndFileUpload, onProgressFileUpload]);

  // const handleDeleteFiles = useCallback(
  //   (filesId) => {
  //     const object = fileNameItem.findIndex((obj) => obj.id === filesId);
  //     const object2 = file.findIndex((obj) => obj.id === filesId);
  //     const object3 = fileList.findIndex((obj) => obj.id === filesId);

  //     if (object > -1) {
  //       dispatch(deleteFile({ id: filesId }));
  //       fileNameItem.splice(object, 1);
  //     }

  //     if (object2 > -1) {
  //       dispatch(deleteFile({ id: filesId }));
  //       file.splice(object, 1);
  //     }

  //     if (object3 > -1) {
  //       dispatch(deleteFile({ id: filesId }));
  //       fileList.splice(object, 1);
  //     }
  //   },
  //   [dispatch, file, fileNameItem, fileList]
  // );

  const statusActiveData = [
    {
      options: [
        { label: "Pending", value: "1" },
        { label: "In Progress", value: "2" },
        { label: "Completed", value: "3" },
      ],
    }];

  const defaultdate = () => {
    return moment(new Date())

      .format("YYYY/MM/DD HH:mm:ss")
      .toString();
  };

  useEffect(() => {
    if (!isSearch) {
      dispatch(resetTaskState());
      dispatch(onGetTasks({ task: taskId }));
      setIsSearch(true);
      // const obj = JSON.parse(localStorage.getItem("authUser"));
      // if (
      //   obj.data &&
      //   obj?.data?.user?.user_position &&
      //   obj?.data?.user?.user_position?.position_role
      // )
      //   setRoles(obj?.data?.user?.user_position?.position_role.method);
      // else setRoles(null);

      // if (obj.data && obj?.data?.user_user)
      //   setUserType(obj?.data?.user_user.userType);
    }
  }, [dispatch, tasks, isSearch, taskId]);

  useEffect(() => {
    if (!isSearch) {
      dispatch(resetTaskDetailState());
      dispatch(onGetTaskDetails({ taskId: taskId }));
      setIsSearch(true);
    }
  }, [dispatch, tasks, isSearch, taskId]);

  useEffect(() => {
    if (!isEmpty(tasks) && !isEmpty(user)) {
      let current = 0;
      setTask(tasks[current]);
      (tasks[current].task_assign || []).forEach((item) => {
        if (item.taska_user.id === user.userId) setIsAssigned(true);
      });
      (tasks[current].task_report || []).forEach((item) => {
        if (item.taskr_user.id === user.userId) setIsReported(true);
      });
    }
  }, [tasks, user]);

  useEffect(() => {
    if (!isEmpty(taskDetails)) {
      setTaskList(taskDetails);
      let minutes = 0;
      for (const item of taskDetails) {
        for (const time of item.tasks_time) {
          const times = Math.round(time.minutes);
          minutes += times;
        }
      }
      setTaskMinutes(minutes);
    }
  }, [taskDetails]);

  useEffect(() => {
    if (!user) {
      const emp = JSON.parse(localStorage.getItem("authUser"));
      if (emp.data) setUser(emp.data);
    }
  }, [user, isAdmin, dispatch]);

  useEffect(() => {
    if (users && !users.length) {
      dispatch(resetUserState());
      dispatch(getUser({ type: "referral", status: 2 }));
    }
  }, [users, isSearch, dispatch]);

  useEffect(() => {
    if (!isEmpty(users)) {
      var data = [];
      var opt = [];
      users.forEach((item, key) => {
        const user_name = item.name;
        const id = item.id;
        const taskListId = item.taskListId;
        const positionId = item.positionId;
        const position_name =
          item.user_position && item.user_position.position_name
            ? item.user_position.position_name
            : "Not set";
        var obj = {
          label: user_name + " - " + position_name,
          value: id,
          taskListId: taskListId,
          positionId: positionId,
        };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
    }
    setUserList(data);
  }, [users]);

  const [filterDate, setFilterDate] = useState(null);

  const handleValidDate = (date) => {
    return moment(date, "YYYY/MM/DD").format("MMM D, YYYY");
  };

  const handleValidTime = (time) => {
    return moment(time, "YYYY/MM/DD HH:mm").format("HH:mm");
  };

  const handleDuration = (minutes) => {
    var h = Math.floor(minutes / 60);
    var m = Math.round(minutes % 60);
    if (h > 0) return h + " hours " + m + " min";
    else return m + " minutes";
  };

  const toggleUser = useCallback(() => {
    if (modalUser) {
      setModalUser(false);
      dispatch(resetUserState());
    } else {
      setModalUser(true);
    }
  }, [modalUser, dispatch]);

  const toggleTimeEntry = useCallback(() => {
    if (modalTimeEntry) {
      setModalTimeEntry(false);
    } else {
      setModalTimeEntry(true);
    }
  }, [modalTimeEntry]);

  const toggleProgress = useCallback(() => {
    if (modalProgress) {
      setModalProgress(false);
      setSelectedFiles([]);
    } else {
      setModalProgress(true);
    }
  }, [modalProgress]);

  const toggleCompleted = useCallback(() => {
    if (modalCompleted) {
      setModalCompleted(false);
    } else {
      setModalCompleted(true);
    }
  }, [modalCompleted]);

  const toggleFile = useCallback(() => {
    if (modalFile) {
      setModalFile(false);
    } else {
      setModalFile(true);
    }
  }, [modalFile]);

  const toggleView = useCallback(() => {
    if (modalView) {
      setModalView(false);
    } else {
      setModalView(true);
    }
  }, [modalView]);

  const validationCompleted = useFormik({
    enableReinitialize: true,
    initialValues: {
      approval_note: (task && task.approval_note) ?? "",
      rating: (task && task.rating) || 0,
    },
    validationSchema: Yup.object({
      approval_note: Yup.string().required("Please Enter Product Option Name"),
    }),
    onSubmit: (values) => {
      dispatch(getTaskLoading());
      dispatch(
        onUpdateTask({
          rating: values.rating,
          approval_note: values.approval_note,
          taskId: taskId ? taskId : 0,
          isCompleted: true,
        })
      );
      validationCompleted.resetForm();
      toggleCompleted();
    },
  });

  const validationTimeEntry = useFormik({
    enableReinitialize: true,
    initialValues: {
      time_sheet_name: (task && task.time_sheet_name) ?? "",
      taskDetailId: "",
      isStop: false,
    },
    validationSchema: Yup.object({
      time_sheet_name: Yup.string().required(
        "Please Enter Product Option Name"
      ),
    }),
    onSubmit: (values) => {
      dispatch(getTaskDetailLoading());
      dispatch(
        onUpdateTaskDetail({
          time_sheet_name: values.time_sheet_name,
          taskDetailId: values.taskDetailId,
          taskId: taskId ? taskId : 0,
          isTimeEntry: true,
          isStop: values.isStop,
        })
      );
      validationTimeEntry.resetForm();
      toggleTimeEntry();
    },
  });

  function handleTimeStop(id) {
    dispatch(getTaskDetailLoading());
    dispatch(
      onUpdateTaskDetail({
        taskDetailId: id,
        taskId: taskId ? taskId : 0,
        isTimeEntry: true,
        isStop: true,
      })
    );
  }

  const validationProgress = useFormik({
    enableReinitialize: true,
    initialValues: { description: "" },
    validationSchema: Yup.object({
      description: Yup.string()
        .required("Please enter description")
        .nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getTaskDetailLoading());
      dispatch(
        onUpdateTaskDetail({
          taskId: taskId ? taskId : 0,
          description: values.description,
          taskDetailId: taskDetail.id,
          isProgress: true,
          isCompleted: true,
        })
      );
      validationProgress.resetForm();
      toggleProgress();
    },
  });

  const validationComment = useFormik({
    enableReinitialize: true,
    initialValues: {
      task_comment: (task && task.task_comment) ?? "",
      taskDetailId: "",
    },
    onSubmit: (values) => {
      dispatch(getTaskDetailLoading());
      dispatch(
        onUpdateTaskDetail({
          task_comment: values.task_comment,
          taskDetailId: values.taskDetailId,
          taskId: taskId ? taskId : 0,
          isComment: true,
          files: otherDocImg.length > 0 ? otherDocImg : [],
        })
      );
      validationComment.resetForm();
      setOtherDocImg([]);
      setFileNameItem([]);
    },
  });

  const validationUser = useFormik({
    enableReinitialize: true,
    initialValues: { user: null ?? "", isReport: false },
    onSubmit: (values) => {
      dispatch(getTaskLoading());
      dispatch(
        onUpdateTask({
          userId: values.user,
          taskId: taskId ? taskId : 0,
          isUser: true,
          isReport: values.isReport,
        })
      );
      validationUser.resetForm();
      toggleUser();
    },
  });

  function handleDeleteAssigned() {
    if (dataToDelete) {
      dispatch(getTaskLoading());
      dispatch(onUpdateTask(dataToDelete));
      setDeleteModalAssigned(false);
      if (dataToDelete.userId === user.userId) setIsAssigned(false);
      setDataToDelete({});
    }
  }

  function handleDeleteReported() {
    if (dataToDelete) {
      dispatch(getTaskLoading());
      dispatch(onUpdateTask(dataToDelete));
      setDeleteModalReported(false);
      if (dataToDelete.userId === user.userId) setIsReported(false);
      setDataToDelete({});
    }
  }
  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  document.title = "Task Detail | Enterprise Resources Planning";

  useEffect(() => {
    if (activeTab === "1-0") {
      let data = document.querySelector("#fUpload");
      if (data) {
        initFile();
      }
    }
  }, [activeTab, initFile]);

  useEffect(() => {
    if (taskList) {
      let data = [];
      for (const task of taskList) {
        for (const file of task.tasks_file) {
          data.push(file);
        }
      }
      setTaskDetailFiles(data);
    }
  }, [taskList]);

  useEffect(() => {
    setFilesUsr(files);
  }, [files]);

  useEffect(() => {
    if (taskList) {
      let data = [];
      for (const item of taskList) {
        for (const file of item.tasks_file) {
          data.push(file);
        }
      }
      setFileList(data);
    }
  }, [taskList]);

  const handleMedia = (filename) => {
    setFilesUsr(process.env.REACT_APP_API_URL + "/media/task/" + filename);
    setModalFile(true);
  };

  const handleView = (filename) => {
    setFileView(process.env.REACT_APP_API_URL + "/media/task/" + filename);
    setModalView(true);
  };

  const renderIconImgList = (fileName) => {
    const type = fileName.split(".");

    switch (type[type.length - 1]) {
      case "sheet":
        return (
          <i
            className='ri-file-excel-line me-1 align-bottom text-success'
            style={{ fontSize: "45px" }}></i>
        );

      case "x-compressed":
        return (
          <i
            className='ri-file-zip-line me-1 align-bottom text-danger'
            style={{ fontSize: "45px" }}></i>
        );

      case "pdf":
        return (
          <i
            className='ri-file-pdf-line me-1 align-bottom text-danger'
            style={{ fontSize: "45px" }}></i>
        );

      default:
        return (
          <img
            src={fileName === "" ? logo : `${api.MEDIA_URL}/media/${fileName}`}
            alt=''
            data-dz-thumbnail=''
            height='30'
            className='avatar-sm rounded bg-light'
            onError={({ currentTarget }) => {
              currentTarget.onerror = null; // prevents looping
              currentTarget.src = imgNotFound;
            }} />
        );
    }
  };

  const renderIcon = (fileName) => {
    const type = fileName.split(".");
    switch (type[type.length - 1]) {
      case "sheet":
        return <i className='ri-file-excel-line me-1 align-bottom text-success'></i>;
      case "x-compressed":
        return <i className='ri-file-zip-line me-1 align-bottom text-danger'></i>;
      case "pdf":
        return <i className='ri-file-pdf-line me-1 align-bottom text-danger'></i>;
      default:
        return <ModalImage showRotate={true} small={`${api.MEDIA_URL}/media/${fileName}-w-50`} large={`${api.MEDIA_URL}/media/${fileName}`} alt={fileName} className="img-thumbnail avatar-xs img-thumbnail user-profile-image" />;
    }
  };

  return (
    <React.Fragment>
      <div className='page-content'>
        <DeleteModal
          show={deleteModalAssigned}
          onDeleteClick={handleDeleteAssigned}
          onCloseClick={() => setDeleteModalAssigned(false)} />
        <DeleteModal
          show={deleteModalReported}
          onDeleteClick={handleDeleteReported}
          onCloseClick={() => setDeleteModalReported(false)} />
        <Container fluid>
          <BreadCrumb title='Tasks Details' pageTitle='Tasks' />
          <Row>
            <Col xxl={3}>
              <Card>
                <CardBody className='text-center'>
                  <h6 className='card-title mb-3 flex-grow-1 text-center'>
                    Time Tracking
                  </h6>
                  <div className='mb-2'>
                    <lord-icon
                      src='https://cdn.lordicon.com/kbtmbyzy.json'
                      trigger='loop'
                      colors='primary:#405189,secondary:#02a8b5'
                      style={{ width: "90px", height: "90px" }}></lord-icon>
                  </div>
                  <h3 className='mb-3'>{handleDuration(taskMinutes)}</h3>
                  <div className='hstack gap-2 justify-content-center'>
                    {isReported && task.statusId !== 2 && (
                      <button
                        type='button'
                        className='btn btn-sm mb-2 btn-primary' onClick={() => {
                          toggleCompleted();
                        }}>
                        <i className='ri-checkbox-circle-line me-1 align-bottom fs-14'></i>
                        Selesai</button>
                    )}
                    {isReported && task.statusId === 2 && (
                      <div>
                        <p className='mb-1 text-muted'>
                          Completed  <span className='badge bg-light text-body me-1 fs-15 fw-medium'>
                            <i className='mdi mdi-star text-warning'></i>
                            {task.rating}
                          </span>
                        </p>
                        <p className='text-dark mb-2'>{task.approval_note} </p>
                        <footer className='blockquote-footer mt-0'>
                          {task.task_approvedby && task.task_approvedby.name}
                        </footer>
                        <button
                          type='button'
                          className='btn btn-sm mb-2 btn-soft-success'
                          onClick={() => {
                            toggleCompleted();
                          }}>
                          <i className='ri-checkbox-circle-line me-1 align-bottom fs-14'></i>
                          Rating Correction
                        </button>
                      </div>
                    )}
                  </div>
                </CardBody>
              </Card>
              <Card className='mb-3'>
                <CardBody>
                  <div className='table-card'>
                    <table className='table mb-0'>
                      <tbody>
                        <tr>
                          <td className='fw-medium'>No. Tugas</td>
                          <td>
                            {task.task_type} #{task.id}
                          </td>
                        </tr>
                        <tr>
                          <td className='fw-medium'>Judul</td>
                          <td>{task.name}</td>
                        </tr>
                        <tr>
                          <td className='fw-medium'>Prioritas</td>
                          <td>
                            {task.priority === "Medium" ? (
                              <span className='badge text-uppercase badge-soft-warning'>
                                {task.priority}
                              </span>
                            ) : task.priority === "Low" ? (
                              <span className='badge text-uppercase badge-soft-success'>
                                {task.priority}
                              </span>
                            ) : (
                              <span className='badge text-uppercase badge-soft-danger'>
                                {task.priority}
                              </span>
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td className='fw-medium'>Status</td>
                          <td>
                            {task.statusId === 1 ? (
                              <span className='badge text-uppercase badge-soft-warning'>
                                In Progress
                              </span>
                            ) : (
                              <span className='badge text-uppercase badge-soft-info'>
                                Completed
                              </span>
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td className='fw-medium'>Periode</td>
                          <td>
                            {handleValidDate(task.startat)}    <small>{handleValidTime(task.startat)}</small>    <br />
                            {handleValidDate(task.endat)}    <small>{handleValidTime(task.endat)}</small>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </CardBody>
              </Card>
              <div className='card mb-3'>
                <div className='card-body'>
                  <div className='d-flex mb-3'>
                    <h6 className='card-title mb-0 flex-grow-1'>Assigned To</h6>
                    <div className='flex-shrink-0'>
                      {isReported && (
                        <button
                          type='button'
                          className='btn btn-light btn-sm'
                          data-bs-toggle='modal'
                          onClick={() => {
                            toggleUser();
                            validationUser.setFieldValue("isReport", false);
                          }}
                          data-bs-target='#inviteMembersModal'>
                          <i className='ri-share-line me-1 align-bottom'></i>  Add
                        </button>
                      )}
                    </div>
                  </div>
                  <ul className='list-unstyled vstack gap-3 mb-0'>
                    {task.task_assign &&
                      task.task_assign.map((item, i) => {
                        return (
                          <li key={i}>
                            <div className='d-flex align-items-center'>
                              <div className='flex-shrink-0'>
                                {item.taska_user.image ? (
                                  <>
                                    <Link
                                      to='#'
                                      className='avatar-group-item'
                                      id={"taimg-" + item.id}>
                                      <img
                                        src={`${api.MEDIA_URL}/media/${item.taska_user.image}-50-50`}
                                        alt=''
                                        className='rounded-circle avatar-xs'
                                      />
                                    </Link>
                                    <UncontrolledTooltip
                                      placement='top'
                                      target={"taimg-" + item.id}>
                                      {item.taska_user.name}
                                    </UncontrolledTooltip>
                                  </>
                                ) : (
                                  <>
                                    <Link
                                      className='avatar-group-item'
                                      id={"taimg-" + item.id}>
                                      <div className='avatar-xs'>
                                        <div className='avatar-title rounded-circle bg-light text-primary'>
                                          {item.taska_user.name
                                            .charAt(0)
                                            .toUpperCase()}
                                        </div>
                                      </div>
                                    </Link>
                                    <UncontrolledTooltip
                                      placement='top'
                                      target={"taimg-" + item.id}>
                                      {item.taska_user.name}
                                    </UncontrolledTooltip>
                                  </>
                                )}
                              </div>
                              <div className='flex-grow-1 ms-2'>
                                <h6 className='mb-1'>
                                  <Link to='/pages-profile'>
                                    {item.taska_user && item.taska_user.name}
                                  </Link>
                                </h6>
                                {/* <p className="text-muted mb-0">{item.taska_user && item.taska_user.user_position && item.taska_user.user_position.position_name}</p> */}
                              </div>
                              {isReported && (
                                <Link
                                  to='#'
                                  className='flex-shrink-0 text-danger'
                                  onClick={() => {
                                    setDataToDelete({
                                      userId: item.taska_user.id,
                                      taskId: taskId ? taskId : 0,
                                      isDeleteUser: true,
                                      isReport: false,
                                    });
                                    setDeleteModalAssigned(true);
                                  }}>
                                  <i className=' ri-close-line fs-15'></i>
                                </Link>
                              )}
                            </div>
                          </li>
                        );
                      })}
                  </ul>
                </div>
              </div>
              <div className='card mb-3'>
                <div className='card-body'>
                  <div className='d-flex mb-3'>
                    <h6 className='card-title mb-0 flex-grow-1'>Report To</h6>
                    <div className='flex-shrink-0'>
                      {isReported && (
                        <button
                          type='button'
                          className='btn btn-light btn-sm'
                          data-bs-toggle='modal'
                          onClick={() => {
                            toggleUser();
                            validationUser.setFieldValue("isReport", true);
                          }}
                          data-bs-target='#inviteMembersModal'>
                          <i className='ri-share-line me-1 align-bottom'></i>Add
                        </button>
                      )}
                    </div>
                  </div>
                  <ul className='list-unstyled vstack gap-3 mb-0'>
                    {task.task_report &&
                      task.task_report.map((item, i) => {
                        return (
                          <li key={i}>
                            <div className='d-flex align-items-center'>
                              <div className='flex-shrink-0'>
                                {item.taskr_user.image ? (
                                  <>
                                    <Link
                                      to='#'
                                      className='avatar-group-item'
                                      id={"trimg-" + item.id}>
                                      <img
                                        src={`${api.MEDIA_URL}/media/${item.taskr_user.image}-50-50`}
                                        alt=''
                                        className='rounded-circle avatar-xs'
                                      />
                                    </Link>
                                    <UncontrolledTooltip
                                      placement='top'
                                      target={"trimg-" + item.id}>
                                      {item.taskr_user.name}
                                    </UncontrolledTooltip>
                                  </>
                                ) : (
                                  <>
                                    <Link
                                      className='avatar-group-item'
                                      id={"trimg-" + item.id}>
                                      <div className='avatar-xs'>
                                        <div className='avatar-title rounded-circle bg-light text-primary'>
                                          {item.taskr_user.name
                                            .charAt(0)
                                            .toUpperCase()}
                                        </div>
                                      </div>
                                    </Link>
                                    <UncontrolledTooltip
                                      placement='top'
                                      target={"trimg-" + item.id}>
                                      {item.taskr_user.name}
                                    </UncontrolledTooltip>
                                  </>
                                )}
                              </div>
                              <div className='flex-grow-1 ms-2'>
                                <h6 className='mb-1'>
                                  <Link to='/pages-profile'>
                                    {item.taskr_user && item.taskr_user.name}
                                  </Link>
                                  <input
                                    className='form-check-input ms-3'
                                    type='radio'
                                    name='flexRadioDefault'
                                    id='flexRadioDefault2'
                                    defaultChecked={item.isAdmin ? true : false}
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      let datas = {
                                        isAdmin: true,
                                        userId: item.userId,
                                        taskId: item.taskId,
                                      };
                                      dispatch(onAddNewTaskDetail(datas));
                                    }} />
                                </h6>
                                {/* <p className="text-muted mb-0">{item.taskr_user && item.taskr_user.user_position && item.taskr_user.user_position.position_name}</p> */}
                              </div>
                              {isReported && (
                                <Link
                                  to='#'
                                  className='flex-shrink-0 text-danger'
                                  onClick={() => {
                                    setDataToDelete({
                                      userId: item.taskr_user.id,
                                      taskId: taskId ? taskId : 0,
                                      isDeleteUser: true,
                                      isReport: true,
                                    });
                                    setDeleteModalReported(true);
                                  }}>
                                  <i className=' ri-close-line fs-15'></i>
                                </Link>
                              )}
                            </div>
                          </li>
                        );
                      })}
                  </ul>
                </div>
              </div>
              <div className='card mb-3'>
                <div className='card-body'>
                  <div className='d-flex mb-3'>
                    <h6 className='card-title mb-0 flex-grow-1'>File Tugas</h6>
                  </div>
                  <ul className='list-unstyled vstack gap-3 mb-0'>
                    {task.task_file &&
                      task.task_file.map((item, i) => {
                        return (
                          <li
                            key={i}
                            onClick={() => {
                              handleMedia(item.filename);
                              setMediaFiles(item);
                            }}>
                            <div className='d-flex align-items-center'>
                              <div className='d-flex align-items-center'>
                                <div className='flex-grow-1'>
                                  <h6 className='form-check-label mb-0 ps-2 text-wrap'>
                                    {item.originalname}
                                  </h6>
                                </div>
                              </div>
                            </div>
                          </li>
                        );
                      })}
                  </ul>
                </div>
              </div>
              <div className='card mb-3'>
                <div className='card-body'>
                  <div className='d-flex mb-3'>
                    <h6 className='card-title mb-0 flex-grow-1'>
                      Detail File Tugas
                    </h6>
                  </div>
                  <ul className='list-unstyled vstack gap-3 mb-0'>
                    {taskDetailFiles &&
                      taskDetailFiles.map((item, i) => {
                        return (
                          <li
                            key={i}
                            onClick={() => {
                              setMediaFiles(item);
                              handleView(item.filename);
                            }}>
                            <div className='d-flex align-items-center'>
                              <div className='d-flex align-items-center'>
                                <div className='flex-grow-1'>
                                  <h6 className='form-check-label mb-0 ps-2 text-wrap'>
                                    {item.originalname}
                                  </h6>
                                </div>
                              </div>
                            </div>
                          </li>
                        );
                      })}
                  </ul>
                </div>
              </div>
            </Col>
            <Col xxl={9}>
              <Card>
                <CardBody>
                  <div>
                    <h5 className='mb-3 fw-semibold text-uppercase'>
                      Keterangan Tugas
                    </h5>
                    <p className='mb-3'>{task.description || "-"}</p>
                  </div>
                  <div>
                    <h5 className='mb-3 fw-semibold text-uppercase'>Grup Usaha</h5>
                    <p className='mb-3'>
                      {task.task_client &&
                        task.task_client.name + " - " + task.task_company.name
                        ? task.task_client &&
                        task.task_client.name + " - " + task.task_company.name
                        : "-"}
                    </p>
                  </div>
                  {/* <div>
                    <h5 className='mb-3 fw-semibold text-uppercase'>Service</h5>
                    <p className='mb-3'>
                      {task.task_service &&
                      task.task_service.name + " - " + task.task_category &&
                      task.task_category?.name
                        ? task.task_service &&
                          task.task_service.name + " - " + task.task_category &&
                          task.task_category?.name
                        : "-"}
                    </p>
                  </div> */}
                </CardBody>
              </Card>

              {taskList &&
                taskList.map((item, i) => {
                  let hasStarted = false;
                  for (const el of item.tasks_time) {
                    if (el.taskDetailId === item.id) {
                      if (!el.endat && el.userId === user.userId) {
                        hasStarted = true;
                      }
                    }
                  }
                  return (
                    <Card key={i}>
                      <CardBody>
                        <div className='d-flex align-items-center'>
                          <div className='flex-grow-1'>
                            <h5>{item.name}</h5>
                            <p className='text-muted'>{item.description}</p>
                          </div>
                          <div className='flex-shrink-0 ms-3'>
                            {taskDetailLoading && (
                              <Spinner size='sm' className='me-2' role='status'>
                                Loading...
                              </Spinner>
                            )}
                            {isAssigned && hasStarted ? (
                              <button
                                type='button'
                                className={
                                  item.isCompleted !== true
                                    ? "btn btn-sm me-2 btn-danger"
                                    : "d-none"
                                }
                                onClick={() => {
                                  handleTimeStop(item.id);
                                }}>
                                <i className=' ri-timer-line align-bottom fs-14'></i>        Berhenti      </button>
                            ) : (
                              <button
                                type='button'
                                className={
                                  item.isCompleted !== true
                                    ? "btn btn-sm me-2 btn-success"
                                    : "d-none"
                                }
                                onClick={() => {
                                  validationTimeEntry.setFieldValue(
                                    "isStop",
                                    false
                                  );
                                  validationTimeEntry.setFieldValue(
                                    "taskDetailId",
                                    item.id
                                  );
                                  toggleTimeEntry();
                                }}>
                                <i className=' ri-timer-line align-bottom fs-14'></i>        Mulai      </button>
                            )}

                            <button
                              type='button'
                              className={
                                item.isCompleted !== true
                                  ? "btn me-2 btn-sm btn-primary"
                                  : "d-none"
                              }
                              onClick={() => {
                                setTaskDetail(item);
                                toggleProgress();
                              }}>
                              <i className='ri-check-line align-bottom fs-14'></i>      Tandai Lengkap
                            </button>
                          </div>
                        </div>
                      </CardBody>
                      <CardHeader>
                        <div className='d-flex align-items-center'>
                          <div className='flex-grow-1'>
                            <Nav
                              className='nav-tabs-custom rounded card-header-tabs border-bottom-0'
                              role='tablist'>
                              <NavItem>
                                <NavLink
                                  href='#'
                                  className={classnames({
                                    active: activeTab === "1-" + i,
                                  })}
                                  onClick={() => {
                                    toggleTab("1-" + i);
                                  }}>
                                  <i className='ri-discuss-line align-bottom fs-14'></i>          Diskusi
                                </NavLink>
                              </NavItem>
                              <NavItem>
                                <NavLink
                                  href='#'
                                  className={classnames({
                                    active: activeTab === "2-" + i,
                                  })}
                                  onClick={() => {
                                    toggleTab("2-" + i);
                                  }}>
                                  <i className='ri-attachment-line align-bottom fs-14'></i>          Lampiran File
                                </NavLink>
                              </NavItem>
                              <NavItem>
                                <NavLink
                                  href='#'
                                  className={classnames({
                                    active: activeTab === "3-" + i,
                                  })}
                                  onClick={() => {
                                    toggleTab("3-" + i);
                                  }}>
                                  <i className='ri-timer-line align-bottom fs-14'></i>          Entri Waktu
                                </NavLink>
                              </NavItem>
                            </Nav>
                          </div>
                        </div>
                      </CardHeader>
                      <CardBody>
                        <TabContent activeTab={activeTab}>
                          <TabPane tabId={"1-" + i}>
                            <Form
                              onSubmit={(e) => {
                                e.preventDefault();
                                validationComment.setFieldValue(
                                  "taskDetailId",
                                  item.id
                                );
                                validationComment.handleSubmit();
                                return false;
                              }}>
                              <Row className='g-3'>
                                <Col lg={12}>
                                  <div className='col-lg-12 mb-3'>
                                    <div className='mb-3 d-flex justify-content-between'>
                                      <Label
                                        htmlFor='education'
                                        className='form-label'>
                                        Dokumen Lainnya
                                        {/* {educationLevelLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )} */}
                                      </Label>
                                      <button
                                        type='button'
                                        className='btn btn-sm btn-label btn-soft-success'
                                        onClick={() => {
                                          // setMediaType("other");
                                          toggleMedia();
                                        }}>
                                        <i className='ri-file-cloud-fill label-icon align-middle fs-16 me-1'></i>                Media
                                      </button>
                                    </div>
                                    {otherDocImg.map((otherDocFile, i) => {
                                      if (otherDocFile.isDeleted) {
                                        return null;
                                      } else {
                                        return (
                                          <div
                                            key={i}
                                            className='border-bottom mb-3'>
                                            <div className='d-flex justify-content-between mb-3 align-items-center'>
                                              <div className='me-2'>
                                                {renderIconImgList(
                                                  otherDocFile.filename
                                                )}
                                              </div>

                                              <div className='text-truncate'>
                                                {otherDocFile.filename}
                                              </div>
                                              <div>
                                                <Link
                                                  to='#'
                                                  className={
                                                    "btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"
                                                  }
                                                  onClick={(e) => {
                                                    // e.stopPropagation();
                                                    handleDeleteFile(
                                                      otherDocFile
                                                    );
                                                  }}>
                                                  <i className='ri-delete-bin-line fs-15 text-danger'></i>
                                                </Link>
                                              </div>
                                            </div>
                                          </div>
                                        );
                                      }
                                    })}
                                  </div>
                                  <Input
                                    name='task_comment'
                                    id='task_comment-field'
                                    rows='3'
                                    className='form-control bg-light border-light'
                                    placeholder='Leave a Comments'
                                    type='textarea'
                                    onChange={validationComment.handleChange}
                                    onBlur={validationComment.handleBlur}
                                    value={
                                      validationComment.values.task_comment
                                    } />
                                </Col>
                                <Col xs={12} className='text-end mb-3'>
                                  <button
                                    type='submit'
                                    className='btn btn-success'>
                                    <span className='d-flex align-items-center'>
                                      <span className='flex-grow-1 me-2'>
                                        Tambah Komentar
                                      </span>
                                      {taskDetailLoading ? (
                                        <Spinner
                                          size='sm'
                                          className='flex-shrink-0'
                                          role='status'>
                                          Loading...
                                        </Spinner>
                                      ) : (
                                        ""
                                      )}
                                    </span>
                                  </button>
                                </Col>
                              </Row>
                            </Form>
                            {item.tasks_note && item.tasks_note.length > 1 ? (
                              <SimpleBar
                                style={{ height: "248px" }}
                                className='px-3 mx-n3 mb-2'>
                                {item.tasks_note.map((note, idn) => {
                                  return (
                                    <div
                                      className='d-flex mb-4'
                                      key={idn + "note"}>
                                      <div className='flex-shrink-0'>
                                        <img
                                          src={
                                            note.taskn_user &&
                                              note.taskn_user.user_image &&
                                              note.taskn_user.user_image.path
                                              ? process.env.REACT_APP_API_URL +
                                              "/files/" +
                                              note.taskn_user.user_image.path
                                              : defaultImg
                                          }
                                          alt=''
                                          className='avatar-xs rounded-circle'
                                        />
                                      </div>
                                      <div className='flex-grow-1 ms-3'>
                                        <h5 className='fs-13'>
                                          <Link to='/pages-profile'>
                                            {note.taskn_user &&
                                              note.taskn_user.name}                    -                    <small>
                                              {note.taskn_user &&
                                                note.taskn_user.user_position &&
                                                note.taskn_user.user_position
                                                  .position_name}
                                            </small>
                                          </Link>
                                          <small className='text-muted ms-2'>
                                            {moment(note.createdat)

                                              .fromNow()}
                                          </small>
                                        </h5>
                                        <p className='text-muted'>
                                          {note.description}
                                        </p>
                                        <Row className='g-2'>
                                          {note.taskn_file.map((f, idf) => {
                                            return (
                                              <Col key={idf}> {renderIcon(f.filename)} <span className="fs-12 fw-normal">{f.originalname}</span></Col>
                                            );
                                          })}
                                        </Row>
                                        <Link
                                          to='#'
                                          className='badge text-muted bg-light'>
                                          <i className='mdi mdi-reply'></i>                  Reply
                                        </Link>
                                      </div>
                                    </div>
                                  );
                                })}
                              </SimpleBar>
                            ) : (
                              <>
                                {item.tasks_note.map((note, idn) => {
                                  return (
                                    <div
                                      className='d-flex mb-4'
                                      key={idn + "note"}>
                                      <div className='flex-shrink-0'>
                                        {note.taskn_user.image ? (
                                          <>
                                            <Link
                                              to='#'
                                              className='avatar-group-item'
                                              id={"nimg-" + note.id}>
                                              <img
                                                src={`${api.MEDIA_URL}/media/${note.taskn_user.image}-50-50`}
                                                alt=''
                                                className='rounded-circle avatar-xs'
                                              />
                                            </Link>
                                            <UncontrolledTooltip
                                              placement='top'
                                              target={"nimg-" + note.id}>
                                              {note.taskn_user.name}
                                            </UncontrolledTooltip>
                                          </>
                                        ) : (
                                          <>
                                            <Link
                                              className='avatar-group-item'
                                              id={"nimg-" + note.id}>
                                              <div className='avatar-xs'>
                                                <div className='avatar-title rounded-circle bg-light text-primary'>
                                                  {note.taskn_user.name
                                                    .charAt(0)
                                                    .toUpperCase()}
                                                </div>
                                              </div>
                                            </Link>
                                            <UncontrolledTooltip
                                              placement='top'
                                              target={"nimg-" + note.id}>
                                              {note.taskn_user.name}
                                            </UncontrolledTooltip>
                                          </>
                                        )}
                                      </div>
                                      <div className='flex-grow-1 ms-3'>
                                        <h5 className='fs-13'>
                                          <Link to='/pages-profile'>
                                            {note.taskn_user &&
                                              note.taskn_user.name}                    -                    <small>
                                              {note.taskn_user.name &&
                                                note.taskn_user.user_position &&
                                                note.taskn_user.user_position
                                                  .name}
                                            </small>
                                          </Link>
                                          <small className='text-muted ms-2'>
                                            {moment(note.createdat)

                                              .fromNow()}
                                          </small>
                                        </h5>
                                        <p className='text-muted'>
                                          {note.description}
                                        </p>
                                        <Row className='g-2 mb-3'>
                                          {/* {note.taskn_file.map((f, idf) => (
                                            <Col key={idf + "file"} lg={1} sm={2} xs={6}>
                                              {f.mimetype.includes("image") ? <img className="img-fluid rounded" alt={f.filename} src={process.env.REACT_APP_API_URL + "/files/" + f.path} /> : <i className="display-6 text-muted ri-function-line" />}
                                            </Col>
                                          ))} */}
                                        </Row>
                                      </div>
                                    </div>
                                  );
                                })}
                              </>
                            )}
                          </TabPane>
                          <TabPane tabId={"2-" + i}>
                            <div className='table-responsive table-card'>
                              <table className='table align-middle table-nowrap mb-0'>
                                <thead className='table-active'>
                                  <tr>
                                    <th scope='col'>File Name</th>
                                    <th scope='col'>Added By</th>
                                    {/* <th scope="col">File Item</th>
                                    <th scope="col">File Size</th> */}
                                    <th scope='col'>Recent Date</th>
                                    {/* <th scope="col" className="text-center">
                                      Actions
                                    </th> */}
                                  </tr>
                                </thead>
                                <tbody id='file-list'>
                                  {(item.tasks_file || []).map((file, key) => (
                                    <tr
                                      onClick={() => {
                                        const typeFile =
                                          file.filename.split(".");
                                        if (
                                          typeFile[typeFile.length - 1] ===
                                          "x-compressed"
                                        ) {
                                          window.open(
                                            `${api.MEDIA_URL}/media/${file.filename}`
                                          );
                                        } else if (
                                          typeFile[typeFile.length - 1] ===
                                          "sheet"
                                        ) {
                                          window.open(
                                            `${api.MEDIA_URL}/media/${file.filename}`
                                          );
                                        } else if (
                                          typeFile[typeFile.length - 1] ===
                                          "pdf"
                                        ) {
                                          window.open(
                                            `${api.MEDIA_URL}/media/${file.filename}`
                                          );
                                        } else {
                                          //
                                        }
                                      }}
                                      key={key + "file"}>
                                      <td>
                                        <input
                                          className='form-control filelist-id'
                                          type='hidden'
                                          value='1'
                                          id='filelist-1'
                                        />
                                        <div className='d-flex align-files-center'>
                                          <div className='flex-shrink-0 fs-17 me-2 filelist-icon'>
                                            <span className=' fs-18 text-info'>
                                              {renderIcon(
                                                file.filename
                                              )}
                                            </span>
                                          </div>
                                          <div className='flex-grow-1 filelist-name'>
                                            {file.filename}
                                          </div>
                                        </div>
                                      </td>
                                      <td>
                                        <Link to='/pages-profile'>
                                          {file.file_task_note &&
                                            file.file_task_note.taskn_user &&
                                            file.file_task_note.taskn_user.name}
                                        </Link>
                                      </td>
                                      {/* <td>{file.mimetype}</td>
                                      <td className="filelist-size">{formatBytes(file.size)}</td> */}
                                      <td className='filelist-create'>
                                        {handleValidDate(file.createdat)}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </TabPane>
                          <TabPane tabId={"3-" + i}>
                            <div className='table-responsive table-card'>
                              <table className='table align-middle mb-0'>
                                <thead className='table-light'>
                                  <tr>
                                    <th scope='col'>Member</th>
                                    <th scope='col'>Date</th>
                                    <th scope='col'>Duration</th>
                                    <th scope='col'>Tasks Title</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {(item.tasks_time || []).map((time, key) => (
                                    <tr key={key + "time"}>
                                      <td>
                                        <div className='d-flex align-items-center'>
                                          <img
                                            src={
                                              time.taskt_user &&
                                                time.taskt_user.user_image &&
                                                time.taskt_user.user_image.path
                                                ? process.env
                                                  .REACT_APP_API_URL +
                                                "/files/" +
                                                time.taskt_user.user_image
                                                  .path
                                                : defaultImg
                                            }
                                            alt=''
                                            className='avatar-xs rounded-circle' />
                                          <div className='flex-grow-1 ms-2'>
                                            <p className='mb-0 fw-medium'>
                                              <Link to='/pages-profile'>
                                                {time.taskt_user &&
                                                  time.taskt_user.name}
                                              </Link>
                                            </p>
                                            <small className='mb-0 text-muted'>
                                              {time.taskt_user &&
                                                time.taskt_user.user_position &&
                                                time.taskt_user.user_position
                                                  .position_name}
                                            </small>
                                          </div>
                                        </div>
                                      </td>
                                      <td>
                                        {handleValidDate(time.startat)}                <small>
                                          {handleValidTime(time.startat)}
                                        </small>
                                      </td>
                                      <td>
                                        {time.minutes &&
                                          handleDuration(time.minutes)}
                                      </td>
                                      <td>{time.time_sheet_name}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </TabPane>
                        </TabContent>
                      </CardBody>
                    </Card>
                  );
                })}
            </Col>
          </Row>
          <Modal id='showModal' isOpen={modalTimeEntry} centered size='md'>
            <ModalHeader className='bg-light p-3' toggle={toggleTimeEntry}>
              Add Time Entry
            </ModalHeader>
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                validationTimeEntry.handleSubmit();
                return false;
              }}>
              <ModalBody>
                <div className='row'>
                  <div className='col-lg-12'>
                    <div className='mb-3'>
                      <Label
                        htmlFor='time_sheet_name-field'
                        className='form-label'>
                        Work in progress
                      </Label>
                      <Input
                        name='time_sheet_name'
                        id='time_sheet_name-field'
                        className='form-control'
                        placeholder='Enter Time Entry Description'
                        type='textarea'
                        onChange={validationTimeEntry.handleChange}
                        onBlur={validationTimeEntry.handleBlur}
                        value={validationTimeEntry.values.time_sheet_name}
                        invalid={
                          validationTimeEntry.touched.time_sheet_name &&
                            validationTimeEntry.errors.time_sheet_name
                            ? true
                            : false
                        }
                      />
                      {validationTimeEntry.touched.time_sheet_name &&
                        validationTimeEntry.errors.time_sheet_name ? (
                        <FormFeedback type='invalid'>
                          {validationTimeEntry.errors.time_sheet_name}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </div>
                </div>
              </ModalBody>
              <div className='modal-footer'>
                <div className='hstack gap-2 justify-content-end'>
                  <button
                    type='button'
                    className='btn btn-light'
                    onClick={() => {
                      setModalTimeEntry(false);
                    }}>
                    Close
                  </button>
                  <button type='submit' className='btn btn-success'>
                    <span className='d-flex align-items-center'>
                      <span className='flex-grow-1 me-2'>Add Time Entry</span>
                      {loading ? (
                        <Spinner
                          size='sm'
                          className='flex-shrink-0'
                          role='status'>
                          Loading...
                        </Spinner>
                      ) : (
                        ""
                      )}
                    </span>
                  </button>
                </div>
              </div>
            </Form>
          </Modal>

          <Modal
            id='showModalProgress'
            isOpen={modalProgress}
            centered
            size='lg'>
            <ModalHeader className='bg-light p-3' toggle={toggleProgress}>
              Add Description
            </ModalHeader>
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                validationProgress.handleSubmit();
                return false;
              }}>
              <ModalBody>
                <div className='mb-3 col-lg-12'>
                  <Label htmlFor='description-field' className='form-label'>
                    Description
                  </Label>
                  <Input
                    name='description'
                    id='description-field'
                    rows='6'
                    className='form-control'
                    placeholder='Description'
                    type='textarea'
                    onChange={validationProgress.handleChange}
                    onBlur={validationProgress.handleBlur}
                    value={validationProgress.values.description}
                    invalid={
                      validationProgress.touched.description &&
                        validationProgress.errors.description
                        ? true
                        : false
                    }/>
                  {validationProgress.touched.description &&
                    validationProgress.errors.description ? (
                    <FormFeedback type='invalid'>
                      {validationProgress.errors.description}
                    </FormFeedback>
                  ) : null}
                </div>
              </ModalBody>
              <div className='modal-footer'>
                <div className='hstack gap-2 justify-content-end'>
                  <button
                    type='button'
                    className='btn btn-light'
                    onClick={() => {
                      setModalProgress(false);
                    }}>
                    Close
                  </button>
                  <button type='submit' className='btn btn-success'>
                    <span className='d-flex align-items-center'>
                      <span className='flex-grow-1 me-2'>Mark Complete</span>
                      {loading ? (
                        <Spinner
                          size='sm'
                          className='flex-shrink-0'
                          role='status'>
                          Loading...
                        </Spinner>
                      ) : (
                        ""
                      )}
                    </span>
                  </button>
                </div>
              </div>
            </Form>
          </Modal>
          <Modal id='showModalUser' isOpen={modalUser} centered size='md'>
            <ModalHeader className='bg-light p-3' toggle={toggleUser}>
              Add User
            </ModalHeader>
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                validationUser.handleSubmit();
                return false;
              }}>
              <ModalBody>
                <div className='row'>
                  <div className='mb-3 col-lg-12'>
                    <Label htmlFor='user' className='form-label'>
                      User
                      {userLoading ? (
                        <Spinner color='primary' size='sm'>
                          Loading...
                        </Spinner>
                      ) : (
                        ""
                      )}
                    </Label>
                    <Select
                      name='user'
                      value={validationUser.values.user}
                      placeholder='Enter User'
                      isMulti
                      onChange={(opt, { option }) => {
                        let newOpts = opt;
                        if (option && option.value === "all") {
                          let filteredOptions = clone(userList);
                          filteredOptions = filteredOptions[0].options.filter(
                            (filteredOption) =>
                              !newOpts.includes(filteredOption)
                          );
                          newOpts = newOpts
                            .concat(filteredOptions)
                            .filter((newOpt) => newOpt.value !== "all");
                        }
                        validationUser.setFieldValue("user", newOpts);
                      }}
                      options={userList}
                      noOptionsMessage={(e) => "Type User to get option"}
                      invalid={
                        validationUser.touched.user &&
                          validationUser.errors.user
                          ? true
                          : false
                      }></Select>
                    {validationUser.touched.user &&
                      validationUser.errors.user ? (
                      <small className='text-danger' type='invalid'>
                        {validationUser.errors.user}
                      </small>
                    ) : null}
                  </div>
                </div>
              </ModalBody>
              <div className='modal-footer'>
                <div className='hstack gap-2 justify-content-end'>
                  <button
                    type='button'
                    className='btn btn-light'
                    onClick={() => {
                      setModalUser(false);
                    }}>
                    Close
                  </button>
                  <button type='submit' className='btn btn-success'>
                    <span className='d-flex align-items-center'>
                      <span className='flex-grow-1 me-2'>Add User</span>
                      {loading && (
                        <Spinner
                          size='sm'
                          className='flex-shrink-0'
                          role='status'>
                          Loading...
                        </Spinner>
                      )}
                    </span>
                  </button>
                </div>
              </div>
            </Form>
          </Modal>
          <Modal id='showModal' isOpen={modalCompleted} centered size='lg'>
            <ModalHeader className='bg-light p-3' toggle={toggleCompleted}>
              Approval Task
            </ModalHeader>
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                validationCompleted.handleSubmit();
                return false;
              }}>
              <ModalBody>
                <div className='row'>
                  <div dir='ltr' className='mb-3 col-lg-12'>
                    <div
                      id='rater-onhover'
                      className='align-middle d-inline fs-22'>
                      <Rating
                        stop={5}
                        emptySymbol='mdi mdi-star-outline text-muted '
                        fullSymbol='mdi mdi-star text-warning '
                        initialRating={validationCompleted.values.rating}
                        onChange={(customize) => {
                          validationCompleted.setFieldValue(
                            "rating",
                            customize
                          );
                        }}
                      />
                    </div>
                    <Badge color='info' className='ratingnum align-middle ms-2'>
                      {validationCompleted.values.rating}
                    </Badge>
                  </div>
                  <div className='mb-3 col-lg-12'>
                    <Label htmlFor='approval_note-field' className='form-label'>
                      Approval Notes
                    </Label>
                    <Input
                      name='approval_note'
                      id='approval_note-field'
                      className='form-control'
                      placeholder='Enter Approval Notes'
                      type='textarea'
                      onChange={validationCompleted.handleChange}
                      onBlur={validationCompleted.handleBlur}
                      value={validationCompleted.values.approval_note}
                      invalid={
                        validationCompleted.touched.approval_note &&
                          validationCompleted.errors.approval_note
                          ? true
                          : false
                      }
                    />
                    {validationCompleted.touched.approval_note &&
                      validationCompleted.errors.approval_note ? (
                      <FormFeedback type='invalid'>
                        {validationCompleted.errors.approval_note}
                      </FormFeedback>
                    ) : null}
                  </div>
                </div>
              </ModalBody>
              <div className='modal-footer'>
                <div className='hstack gap-2 justify-content-end'>
                  <button
                    type='button'
                    className='btn btn-light'
                    onClick={() => {
                      setModalCompleted(false);
                    }}>
                    Close
                  </button>
                  <button type='submit' className='btn btn-success'>
                    <span className='d-flex align-items-center'>
                      <span className='flex-grow-1 me-2'>Set Completed</span>
                      {loading ? (
                        <Spinner
                          size='sm'
                          className='flex-shrink-0'
                          role='status'>
                          Loading...
                        </Spinner>
                      ) : (
                        ""
                      )}
                    </span>
                  </button>
                </div>
              </div>
            </Form>
          </Modal>
          <Modal id='showModal' isOpen={modalFile} centered size='lg'>
            <ModalHeader className='bg-light p-3' toggle={toggleFile}>
              Task Files
            </ModalHeader>
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                // validationCompleted.handleSubmit();
                return false;
              }}>
              <ModalBody>
                <div className='row'>
                  <div className='mb-3 col-lg-12'>
                    <img
                      src={filesUsr}
                      alt=''
                      className='form-check-label'
                      style={{ width: "100%" }}
                    />
                  </div>
                </div>
              </ModalBody>
              <div className='modal-footer'>
                <div className='hstack gap-2 justify-content-end'>
                  <button
                    type='button'
                    className='btn btn-light'
                    onClick={() => {
                      setModalFile(false);
                    }}>
                    Close
                  </button>
                  {/* <button type="submit" className="btn btn-success">
                                        <span className="d-flex align-items-center">
                                            <span className="flex-grow-1 me-2">Done</span>
                                            {loading ? (<Spinner size="sm" className="flex-shrink-0" role="status">Loading...</Spinner>) : ("")}
                                        </span>
                                    </button> */}
                </div>
              </div>
            </Form>
          </Modal>
          <Modal id='showModal' isOpen={modalView} centered size='lg'>
            <ModalHeader className='bg-light p-3' toggle={toggleView}>
              Task Detail Files
            </ModalHeader>
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                // validationCompleted.handleSubmit();
                return false;
              }}>
              <ModalBody>
                <div className='row'>
                  <div className='mb-3 col-lg-12'>
                    <img
                      src={fileView}
                      alt=''
                      className='form-check-label'
                      style={{ width: "100%" }}
                    />
                  </div>
                </div>
              </ModalBody>
              <div className='modal-footer'>
                <div className='hstack gap-2 justify-content-end'>
                  <button
                    type='button'
                    className='btn btn-light'
                    onClick={() => {
                      setModalView(false);
                    }}>
                    Close
                  </button>
                  {/* <button type="submit" className="btn btn-success">
                        <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">Done</span>
                            {loading ? (<Spinner size="sm" className="flex-shrink-0" role="status">Loading...</Spinner>) : ("")}
                        </span>
                    </button> */}
                </div>
              </div>
            </Form>
          </Modal>
          <ModalInputFile
            onSelect={handleSelectFile}
            loading={loading}
            modal={modalMedia}
            toggle={toggleMedia} />
          
        </Container>
      </div>
    </React.Fragment>
  );
};

export default TaskDetails;